import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import FileSaver from 'file-saver';
import Moment from 'moment';
import { Localization } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import Services from './Services';
import { ProgressButton } from '../../../commons/ProgressButton';
import RFForm from '../../../components/Form/RFForm';
import { DatetimePicker } from '../../../commons/controls';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../JegyertekesitesTooltips';
import TimeFormatter from '../../../commons/TimeFormatter';

// momentLocalizer(Moment);
Moment.locale('hu');
const localizer = new momentLocalizer(Moment);

class ListakContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgalmiJelentesXlsxButtonLoading: false,
      forgalmiJelentesPdfButtonLoading: false,
      napiJelentesXlsxButtonLoading: false,
      napiJelentesPdfButtonLoading: false,
      tol: Moment().startOf('day').toDate(),
      ig: Moment().endOf('day').toDate(),
    };
  }

  componentDidMount() {
    this.selected = false;
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      // if (this.props.active) {
      // }
    }
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMIDOSZAKTOL':
          this.setState({ tol: (Moment(e).startOf('day')) });
          break;
        case 'FORMIDOSZAKIG':
          this.setState({ ig: (Moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMIDOSZAKTOL':
          //this.handleDateInputChange(e, v, 'reszletesForgalomKezdete')
          if (!e)
            e = new Date();
          this.setState({ tol: e });
          break;
        case 'FORMIDOSZAKIG':
          if (!e)
            e = new Date();
          this.setState({ ig: e });
          break;
        default:
          break;
      }
    }
  }

  onLekerdezesClick = () => {
    this.setState({
      forgalmiJelentesXlsxButtonLoading: true
    });

    Services.exportZaras(this.state.tol && TimeFormatter.formatIso(this.state.tol), this.state.ig && TimeFormatter.formatIso(this.state.ig), (err, res) => {
      if (!err) {
        this.setState({
          forgalmiJelentesXlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), `Időszaki forgalmi jelentés ${TimeFormatter.formatDateTime(this.state.tol)} - ${TimeFormatter.formatDateTime(this.state.ig)}`);
      } else {
        this.setState({
          forgalmiJelentesXlsxButtonLoading: false
        });
      }
    });
  }

  onLekerdezesClick2 = () => {
    this.setState({
      forgalmiJelentesXlsxButtonLoading: true
    });

    Services.exportZaras2(this.state.tol && TimeFormatter.formatIso(this.state.tol), this.state.ig && TimeFormatter.formatIso(this.state.ig), (err, res) => {
      if (!err) {
        this.setState({
          forgalmiJelentesXlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), `Nézőszám jelentés ${TimeFormatter.formatDateTime(this.state.tol)} - ${TimeFormatter.formatDateTime(this.state.ig)}.xlsx`);
      } else {
        this.setState({
          forgalmiJelentesXlsxButtonLoading: false
        });
      }
    });
  }

  onLekerdezesPdfClick = () => {
    this.setState({
      forgalmiJelentesPdfButtonLoading: true
    });

    Services.exportZarasPdf(this.state.tol && TimeFormatter.formatIso(this.state.tol), this.state.ig && TimeFormatter.formatIso(this.state.ig), (err, res) => {
      if (!err) {
        this.setState({
          forgalmiJelentesPdfButtonLoading: false
        });
        this.props.globals.addSuccess('Pdf fájl letöltés indítása...');
        const pdf = new Blob([res[0]], { type: 'application/pdf', responseType: 'arraybuffer' });
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      } else {
        this.setState({
          forgalmiJelentesPdfButtonLoading: false
        });
      }
    });
  }

  onNapiJelentesClick = () => {
    this.setState({
      napiJelentesXlsxButtonLoading: true
    });

    Services.exportNapi(this.state.tol && TimeFormatter.formatIso(this.state.tol), this.state.ig && TimeFormatter.formatIso(this.state.ig), (err, res) => {
      if (!err) {
        this.setState({
          napiJelentesXlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), `Nézőszám jelentés ${TimeFormatter.formatDateTime(this.state.tol)} - ${TimeFormatter.formatDateTime(this.state.ig)}.xlsx`);
      } else {
        this.setState({
          napiJelentesXlsxButtonLoading: false
        });
      }
    });
  }

  onNapiJelentesPdfClick = () => {
    this.setState({
      napiJelentesPdfButtonLoading: true
    });

    Services.exportNapiPdf(this.state.tol && TimeFormatter.formatIso(this.state.tol), this.state.ig && TimeFormatter.formatIso(this.state.ig), (err, res) => {
      if (!err) {
        this.setState({
          napiJelentesPdfButtonLoading: false
        });
        this.props.globals.addSuccess('Pdf fájl letöltés indítása...');
        const pdf = new Blob([res[0]], { type: 'application/pdf', responseType: 'arraybuffer' });
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      } else {
        this.setState({
          napiJelentesPdfButtonLoading: false
        });
      }
    });
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <Localization date={localizer}>
        <div>
          <div className="animated fadeIn">
            <div className="card">
              <div className="card-header">
                Lekérdezések
                <CustomTooltip text={getTooltip('lekerdezesek')} id="lekerdezesekTT" />
                {/* <YouTube data={videoData} /> */}
              </div>
              <div style={cardStyle}>
                <RFForm onSubmit={() => {}}>
                  <div className="col-md-12" style={{ marginTop: 25 }}>
                    <h4>
                      {'Lekérdezések:'}
                    </h4>
                  </div>
                  <div className="col-md-12" style={{ maxWidth: 350 }}>
                    <DatetimePicker
                      label={'Időszak-tól:'}
                      containerClassName="organw-date-time"
                      // format="YYYY-MM-DD HH:mm:ss"
                      messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                      value={this.state.tol && new Date(this.state.tol)}
                      // onChange={(e, v) => this.handleDateInputChange(e, v, 'tol')}
                      onChange={(e,v) => {this.handleDateChange(e,v,'FORMIDOSZAKTOL')}} 
                      onSelect={(e,v) => { this.selected = true }}
                      ref={ tol => this.tol = tol }
                      name="tol"
                      id="tol"
                      style={{ borderRadius: 0 }}
                      timePrecision="seconds"
                      />
                    <DatetimePicker
                      label={'Időszak-ig:'}
                      containerClassName="organw-date-time"
                      // format="YYYY-MM-DD HH:mm:ss"
                      messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                      value={this.state.ig && new Date(this.state.ig)}
                      // onChange={(e, v) => this.handleDateInputChange(e, v, 'ig')}
                      onChange={(e,v) => {this.handleDateChange(e,v,'FORMIDOSZAKIG')}}
                      onSelect={(e,v) => { this.selected = true }}
                      ref={ ig => this.ig = ig }
                      name="ig"
                      id="ig"
                      timePrecision="seconds"
                    />
                  </div>
                  <div className="col-md-12">
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_FORGALOM_XLSX']) && (
                      <ProgressButton
                        style={{
                          marginBottom: 8,
                          marginTop: 12,
                          marginRight: 8,
                          cursor: this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading ? 'not-allowed' : 'pointer'
                        }}
                        color="primary"
                        type="button"
                        onClick={this.onLekerdezesClick}
                        loading={this.state.forgalmiJelentesXlsxButtonLoading}
                        className="pull-left table-new-button"
                        disabled={this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading}
                      >
                        {'Időszaki forgalmi jelentés XLSX'}
                      </ProgressButton>
                    )}
                    {' '}
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_FORGALOM_PDF']) && (
                      <ProgressButton
                        style={{
                          marginBottom: 8,
                          marginTop: 12,
                          marginRight: 8,
                          cursor: this.state.forgalmiJelentesXlsxButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading ? 'not-allowed' : 'pointer'
                        }}
                        color="primary"
                        type="button"
                        onClick={this.onLekerdezesPdfClick}
                        loading={this.state.forgalmiJelentesPdfButtonLoading}
                        className="pull-left table-new-button"
                        disabled={this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading}
                      >
                        {'Időszaki forgalmi jelentés PDF'}
                      </ProgressButton>
                    )}
                    {' '}
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_XLSX']) && (
                      <ProgressButton
                        style={{
                          marginBottom: 8,
                          marginTop: 12,
                          marginRight: 8,
                          cursor: this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesPdfButtonLoading ? 'not-allowed' : 'pointer'
                        }}
                        color="primary"
                        type="button"
                        onClick={this.onNapiJelentesClick}
                        loading={this.state.napiJelentesXlsxButtonLoading}
                        className="pull-left table-new-button"
                        disabled={this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading}
                      >
                        {'Nézőszám jelentés XLSX'}
                      </ProgressButton>
                    )}
                    {' '}
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_PDF']) && (
                      <ProgressButton
                        style={{
                          marginBottom: 8,
                          marginTop: 12,
                          marginRight: 8,
                          cursor: this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading ? 'not-allowed' : 'pointer'
                        }}
                        color="primary"
                        type="button"
                        onClick={this.onNapiJelentesPdfClick}
                        loading={this.state.napiJelentesPdfButtonLoading}
                        className="pull-left table-new-button"
                        disabled={this.state.forgalmiJelentesXlsxButtonLoading || this.state.forgalmiJelentesPdfButtonLoading || this.state.napiJelentesXlsxButtonLoading || this.state.napiJelentesPdfButtonLoading}
                      >
                        {'Nézőszám jelentés PDF'}
                      </ProgressButton>
                    )}
                  </div>
                </RFForm>
              </div>
            </div>
          </div>
        </div>
      </Localization>
    );
  }
}

ListakContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default ListakContent;
